export class EmployeeCustomTimeSchedule {
    employeeCustomTimeScheduleId: number;
    rangeDaysType: number;
    dateFrom: Date;
    dateTo: Date;
    allowEdit: boolean;
}